import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

declare var $: any;

@Component({
    selector: 'itpx-link-create',
    templateUrl: './link-create.component.html',
    styleUrls: ['./link-create.component.css']
})
export class LinkCreateComponent implements AfterViewInit {

    text: string;
    url: string;
    @Input() collectText: boolean;
    @ViewChild('dropdown') dropdownRef: ElementRef;
    @ViewChild('urlInput') urlInputRef: ElementRef;

    @Output()
    onUrlAdded = new EventEmitter<{ href: string, text?: string }>();
    @Output()
    onResetFocus = new EventEmitter();

    ngAfterViewInit() {
        $(this.dropdownRef.nativeElement).on('show.bs.dropdown', () => {
            setTimeout(() => this.urlInputRef.nativeElement.focus(), 1);
        });
    }

    onAdd(e: Event) {
        this.onUrlAdded.emit({ href: this.url, text: this.text });
        this.closeDropdown(e);
    }

    onCancel(e: Event) {
        this.closeDropdown(e);
    }

    preventDropdownClose(e: MouseEvent) {
        e.stopPropagation();
    }

    private closeDropdown(e: Event) {
        if (e) e.preventDefault();
        this.onResetFocus.emit();
        $('[data-toggle="dropdown"]').parent().removeClass('open');
        this.url = null;
        this.text = null;
    }

    up(e: KeyboardEvent) {
        switch (e.keyCode) {
            /* enter */
            case 13:
                this.onAdd(e);
                break;
            /* esc */
            case 27:
                this.onCancel(e);
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/silk/toolbars/standard-toolbar/link-create/link-create.component.ts